module.exports = __webpack_public_path__ + "img/transfer_hover_93e2ebc.webp";